import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * Container component for centering and constraining content width
 */
const Container = React.forwardRef(
    ({ className, size = "default", ...props }, ref) => {
        const sizeClasses = {
            sm: "max-w-3xl",
            default: "max-w-7xl",
            lg: "max-w-screen-2xl",
            full: "max-w-full",
        }

        return (
            <div
                ref={ref}
                className={cn(
                    "mx-auto w-full px-md md:px-lg",
                    sizeClasses[size],
                    className
                )}
                {...props}
            />
        )
    }
)
Container.displayName = "Container"

export { Container }
